export enum UserResponsibilityEntityType {
    ProcessingActivity = 1,
    System = 2,
    LegalEntity = 3,
    Policy = 4,
    AnnualWheelActivity = 5,
    Task = 6,
    LegalEntityAudit = 7,
    LegalEntityAuditGroup = 8,
    InternalAssessment = 9,
    LegalEntityDocument = 10,
    Contract = 11,
    ContractDocument = 12,
    Sharing = 13,
    PublicInternalAssessmentTemplate = 14,
    Framework = 15,
    Obligation = 16,
    RiskMitigationPlan = 17,
    RiskArea = 18,
    InternalAssessmentGroup = 19,
    IncidentLogEntry = 20,
    Process = 21,
}

export interface UserResponsibilityCountViewModel {
    entityType: UserResponsibilityEntityType;
    count: number;
}

export interface UserResponsibilityCountTableModel extends UserResponsibilityCountViewModel {
    entityName: string;
}

export interface UserResponsibilityDetailViewModel {
    entityId: string;
    entityName: string;
    propertyType: UserResponsibilityPropertyType | null;
    customFieldId: string | null;
    customFieldName: string | null;
    deadline: string | null;
    groupEntity: string | null;
    parentEntityName: string | null;
    sender: string | null;
    recipient: string[] | null;
    contractUserFriendlyId: number | null;
    riskEntityType: number | null;
    scenarioName: string | null;
}

export interface UserResponsibilityDetailRowModel extends UserResponsibilityDetailViewModel {
    propertyTypeName: string | null;
    deadlineName: string | null;
    groupEntityName: string | null;
    riskEntityTypeName: string | null;
}

export interface TransferSelectedResponsibilitiesModel {
    fromUserId: string;
    toUserId: string;
    entityType: UserResponsibilityEntityType;
    entities: Array<TransferResponsibilityEntity>;
}

export interface TransferResponsibilityEntity {
    entityId: string;
    propertyType: UserResponsibilityPropertyType | null;
    customFieldId: string | null;
}

export enum UserResponsibilityPropertyType {
    Responsible = 1,
    SharedResponsible = 2,
    Assignee = 3,
    Owner = 4,
    ContractManager = 5,
    AdditionalAccess = 6,
    DataProcessor = 7,
    Disclosure = 8,
    JointDataController = 9,
    Source = 10,
    FrameworkOwner = 11,
    ControlCoordinator = 12,
    DataController = 13,
    Approver = 14,
}
